import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'apmServiceHours',
    collectionActionName: 'APM_SERVICE_HOURS',
    itemActionName: 'APM_SERVICE_HOURS_ITEM',
});
